import { ReactNode } from 'react';
import { InterfaceButton, InterfaceLink, Link } from '@tiendanube/components';
import { useResponsive } from 'commons/components';
import BackNavigation from '../BackNavigation';

import './HeaderTop.scss';

export interface HeaderTopProps {
  navigation?: Pick<InterfaceButton, 'children' | 'onClick'>;
  mainAction?: Pick<
    InterfaceLink,
    'appearance' | 'children' | 'onClick' | 'icon' | 'spinner' | 'disabled'
  >;
  actions?: ReactNode;
  showAllways?: boolean;
}

function HeaderTop({
  navigation,
  mainAction,
  actions,
  showAllways = false,
}: HeaderTopProps): JSX.Element | null {
  const { isMobile } = useResponsive();

  if (!(isMobile || showAllways)) return null;

  const renderBackNavigation = navigation && (
    <BackNavigation onClick={navigation.onClick}>
      {navigation.children}
    </BackNavigation>
  );

  const renderMainAction = mainAction && (
    <Link
      appearance={mainAction.appearance}
      icon={mainAction.icon}
      onClick={mainAction.onClick}
      spinner={mainAction.spinner}
      disabled={mainAction.disabled}
    >
      {mainAction.children}
    </Link>
  );

  return (
    <div className="page-mobile-navbar">
      {renderBackNavigation}
      <div className="page-mobile-navbar__toolbar">
        {renderMainAction}
        {actions}
      </div>
    </div>
  );
}

export default HeaderTop;
